module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousDash
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Reports")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "gutr"
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-2",
      modifiers: {
        "collapse-2": true
      }
    }],
    staticClass: "m-1",
    attrs: {
      "variant": "outline-dark"
    }
  }, [_vm._v("Filters")]), _vm._v(" "), _c('b-dropdown', {
    staticClass: "m-2 pull-right",
    attrs: {
      "size": "sm",
      "dropleft": "",
      "variant": "outline-dark",
      "text": "Export"
    }
  }, [_c('b-dropdown-item-button', {
    on: {
      "click": _vm.onDownloadExcel
    }
  }, [_vm._v("Export as Excel")])], 1), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    }
  }, [_c('b-card', {
    staticClass: "gutr"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "isDisabled": _vm.clientType == '2',
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.clientId),
      callback: function($$v) {
        _vm.clientId = $$v
      },
      expression: "clientId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.jTypeList,
      "option-value": "jTypeVal",
      "option-text": "jTypeText",
      "placeholder": "Select Job Type "
    },
    model: {
      value: (_vm.jobType),
      callback: function($$v) {
        _vm.jobType = $$v
      },
      expression: "jobType"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "option-value": "shipmentTypeVal",
      "option-text": "shipmentTypeText",
      "placeholder": "Select Sea / Air"
    },
    model: {
      value: (_vm.shipmentType),
      callback: function($$v) {
        _vm.shipmentType = $$v
      },
      expression: "shipmentType"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeName,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select Export / Import"
    },
    model: {
      value: (_vm.transportType),
      callback: function($$v) {
        _vm.transportType = $$v
      },
      expression: "transportType"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceDataPOR,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      }
    },
    model: {
      value: (_vm.PORfilter),
      callback: function($$v) {
        _vm.PORfilter = $$v
      },
      expression: "PORfilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceDataPOD,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Port of Discharge"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      }
    },
    model: {
      value: (_vm.PODfilter),
      callback: function($$v) {
        _vm.PODfilter = $$v
      },
      expression: "PODfilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceDataLP,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Load Port"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataLP')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataLP')
      }
    },
    model: {
      value: (_vm.LPfilter),
      callback: function($$v) {
        _vm.LPfilter = $$v
      },
      expression: "LPfilter"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.commodityList,
      "option-value": "commodityId",
      "option-text": "itemDescription",
      "placeholder": "Select Commodity"
    },
    on: {
      "searchchange": function($event) {
        _vm.getCommodityList($event, 'commodityList')
      }
    },
    model: {
      value: (_vm.commodityFilter),
      callback: function($$v) {
        _vm.commodityFilter = $$v
      },
      expression: "commodityFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.containerList,
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    model: {
      value: (_vm.containerFilter),
      callback: function($$v) {
        _vm.containerFilter = $$v
      },
      expression: "containerFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.shippingList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.shippingFilter),
      callback: function($$v) {
        _vm.shippingFilter = $$v
      },
      expression: "shippingFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.airlineList,
      "option-value": "airlineId",
      "option-text": "airlineName",
      "placeholder": "Select Airline "
    },
    model: {
      value: (_vm.airlineFilter),
      callback: function($$v) {
        _vm.airlineFilter = $$v
      },
      expression: "airlineFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr table-responsive"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "bordered": "",
      "items": _vm.consoBooking,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "allModuleId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "shipmentType",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.shipmentType == "1" ? "SEA" : "AIR") + " -\n                  " + _vm._s(row1.item.transportType))])]
      }
    }, {
      key: "multiConNo",
      fn: function(row2) {
        return [(row2.item.shipmentType == '1') ? _c('div', [_c('span', [_vm._v("\n                    Container Type : " + _vm._s(row2.item.multipleContainerType) + "\n                    "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                    No.of Containers : " + _vm._s(row2.item.multiConNo) + "\n                    "), _c('br')])]) : _c('div', [_c('span', [_vm._v("\n                    No.of Packages : " + _vm._s(row2.item.noOfPkg) + "\n                    "), _c('br')])])]
      }
    }, {
      key: "POR",
      fn: function(row3) {
        return [(row3.item.shipmentType == '1') ? _c('div', [_c('span', [_vm._v("\n                    Place of Receipt : " + _vm._s(row3.item.POR) + "\n                    "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                    Port of Load : " + _vm._s(row3.item.LP) + "\n                    "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                    Port of Discharge : " + _vm._s(row3.item.POD) + "\n                    "), _c('br')])]) : _c('div', [_c('span', [_vm._v("\n                    Departure Airport : " + _vm._s(row3.item.departAirport) + "\n                    "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                    Destination Airport : " + _vm._s(row3.item.destiAirport) + "\n                    "), _c('br')])])]
      }
    }, {
      key: "mainSalesSeries",
      fn: function(row4) {
        return [(
          row4.item.ffExecutionSeries != null &&
          row4.item.ffExecutionSeries != ''
        ) ? _c('span', [_vm._v("\n                  " + _vm._s(row4.item.ffExecutionSeries) + "\n                  "), _c('br')]) : _c('span', [_vm._v("\n                  " + _vm._s(row4.item.mainSalesSeries) + "\n                  "), _c('br')])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    staticClass: "mt-4 pull-right",
    attrs: {
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows,
      "first-text": "⏮",
      "prev-text": "⏪",
      "next-text": "⏩",
      "last-text": "⏭"
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6420cc95","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/dashboard/dashboardReportsExecList.vue
// module id = 2687
// module chunks = 0